<script setup lang="ts">
  const props = withDefaults(
    defineProps<{
      title: string;
      sectionInfo: {
        responsible?: string;
        cargo?: string;
        date?: string;
      };
      showCargo?: boolean;
    }>(),
    {
      showCargo: true,
    }
  );

  const getDisplayValue = (value?: string): string => {
    if (!value?.trim()) return '-';

    return value;
  };
</script>

<template>
  <div class="border-t border-gray-02 divide-y divide-gray-02 py-6">
    <div>
      <span class="text-[var(--theme-secondary-ink)] text-[15px] font-semibold">{{ title }}</span>
      <div class="flex gap-6 justify-between mt-8 text-sm">
        <div class="flex flex-col gap-2 text-gray-700" :class="showCargo ? 'w-1/3' : 'flex-1'">
          <span class="font-semibold">Responsável</span>
          <span class="border border-border-color rounded-2xl p-5">
            {{ getDisplayValue(props.sectionInfo.responsible) }}
          </span>
        </div>
        <div v-if="showCargo" class="w-1/3 flex flex-col gap-2 text-gray-700">
          <span class="font-semibold">Cargo</span>
          <span class="border border-border-color rounded-2xl p-5">
            {{ getDisplayValue(props.sectionInfo.cargo) }}
          </span>
        </div>
        <div class="w-1/3 flex flex-col gap-2 text-gray-700">
          <span class="font-semibold">Data</span>
          <span class="border border-border-color rounded-2xl p-5">
            {{ getDisplayValue(props.sectionInfo.date) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
